/**
 * Query key dictionary. Every key in one place (OnEarly `app` convention) so
 * invalidation is grep-able and typos are compile errors.
 */
export const queryKeys = {
  me: () => ['me'] as const,
  today: (date: string, locale: string) => ['today', date, locale] as const,
  progress: () => ['progress'] as const,
  library: (handle: string) => ['library', handle] as const,
  libraryPassage: (lineageUuid: string) => ['library', 'passage', lineageUuid] as const,
  savedShelf: () => ['library', 'saved'] as const,
  preferences: () => ['preferences'] as const,
  friends: () => ['friends'] as const,
  group: (groupId: string) => ['group', groupId] as const,
  groupMembership: (groupActorUuid: string) => ['group', groupActorUuid, 'membership'] as const,
  workbook: () => ['workbook'] as const,
  sessions: () => ['sessions'] as const,
  marks: (memberActorUuid: string) => ['marks', memberActorUuid] as const,
  groupProgress: (weekStart: string) => ['group-progress', weekStart] as const,
  subGroupProgress: (groupActorUuid: string, today: string) =>
    ['sub-group-progress', groupActorUuid, today] as const,
  groupInfo: (groupActorUuid: string) => ['group', groupActorUuid, 'info'] as const,
  groupMemberCount: (groupActorUuid: string) => ['group', groupActorUuid, 'member-count'] as const,
  signUpRegions: () => ['sign-up-regions'] as const,
  myGroups: () => ['my-groups'] as const,
  visibleGroup: (groupActorUuid: string) => ['group', groupActorUuid, 'visible'] as const,
  /** Every group's dashboard: what a completion or a mark makes stale. */
  groupDashboards: () => ['group-dashboard'] as const,
  groupDashboard: (viewerId: string | undefined, groupActorUuid: string) =>
    ['group-dashboard', viewerId, groupActorUuid] as const,
  groupPeople: (groupActorUuid: string) => ['group', groupActorUuid, 'people'] as const,
  groupRoles: (groupActorUuid: string) => ['group', groupActorUuid, 'roles'] as const,
  groupInvites: (groupActorUuid: string) => ['group', groupActorUuid, 'invites'] as const,
  myInvite: (inviteUuid: string) => ['my-invite', inviteUuid] as const,
  myPendingInvites: () => ['my-invite', 'pending'] as const,
} as const;

export type QueryKey = ReturnType<(typeof queryKeys)[keyof typeof queryKeys]>;
